import { NavLink } from 'react-router-dom';
import { Mail, Phone, Instagram, Twitter, Facebook } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-primary-dark text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">
          <div>
            <Logo className="mb-4" />
            <p className="text-neutral-200 mb-4">
              Professional sheep pedigree management software for all sheep breeders.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-white hover:text-accent transition-colors" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-white hover:text-accent transition-colors" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-white hover:text-accent transition-colors" aria-label="Instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-sans font-semibold text-lg mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <NavLink to="/" className="text-neutral-200 hover:text-white transition-colors">
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/what-it-does" className="text-neutral-200 hover:text-white transition-colors">
                  What It Does
                </NavLink>
              </li>
              <li>
                <NavLink to="/subscription" className="text-neutral-200 hover:text-white transition-colors">
                  Subscription
                </NavLink>
              </li>
              <li>
                <NavLink to="/history" className="text-neutral-200 hover:text-white transition-colors">
                  History
                </NavLink>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-sans font-semibold text-lg mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-neutral-200 hover:text-white transition-colors">
                  FAQs
                </a>
              </li>
              <li>
                <a href="#" className="text-neutral-200 hover:text-white transition-colors">
                  User Guide
                </a>
              </li>
              <li>
                <a href="#" className="text-neutral-200 hover:text-white transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <a href="#" className="text-neutral-200 hover:text-white transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-neutral-200 hover:text-white transition-colors">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-sans font-semibold text-lg mb-4">Contact Us</h3>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Mail size={18} className="text-accent" />
                <a href="mailto:pedigreepro@outlook.com" className="text-neutral-200 hover:text-white transition-colors">
                  pedigreepro@outlook.com
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={18} className="text-accent" />
                <a href="tel:+44 00000000" className="text-neutral-200 hover:text-white transition-colors">
                  +44 (not displayed)
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-gray-700 text-center text-neutral-400">
          <p>&copy; {new Date().getFullYear()} PedigreePro. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;